/* src/app/umbrella-common/components/internal-documents/internal-document-entry/internal-document-entry.style.scss */
.document {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  border-bottom: #e6e6e6 solid 1px;
  padding-bottom: 3px;
}
.document .file-row {
  width: 275px;
  max-width: 275px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
}
.document .document-name {
  font-weight: bold;
  width: 335px;
  max-width: 335px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
  font-family: Arial, sans-serif;
  font-size: 15px;
  line-height: 1.33;
  color: #585858;
}
.document .created {
  margin-top: 3px;
  font-family: Arial, sans-serif;
  font-size: 12px;
  line-height: 1.33;
  color: #585858;
}
.document .document-link {
  cursor: pointer;
  margin-right: 20px;
  color: #007d40;
  width: 25px;
  height: 25px;
}
.document .delete-icon {
  cursor: pointer;
  margin-right: 10px;
  color: #ee7f00;
  width: 25px;
  height: 25px;
}
.delete-popover {
  display: flex;
  justify-content: left;
  flex-direction: column;
  padding: 20px;
  min-width: 292px;
  font-family: Arial, sans-serif;
  font-size: 15px;
  line-height: 1.33;
  color: #585858;
}
.delete-popover h6 {
  margin-top: 0;
  margin-bottom: 8px;
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  letter-spacing: normal;
  color: #007d40;
}
.delete-popover .buttons {
  display: flex;
  justify-content: flex-start;
  margin-top: 20px;
}
.delete-popover .buttons waiting-spinner {
  margin-right: 5px;
}
.delete-popover .buttons .cancel-button {
  margin-right: 11px;
}
/*# sourceMappingURL=internal-document-entry.style.css.map */
